import React from "react";
import { Card, Space, Alert } from "antd";
import {
  CheckSquareOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";

const StatusCard = () => (
  <Card title="Estados" bordered={false}>
    <Space direction="vertical" style={{ width: "100%" }} size="middle">
      <Alert
        message="Activo"
        description="Acceso y funcionamiento normal del sistema"
        type="success"
        showIcon
        icon={<CheckSquareOutlined />}
        className="licences-alert-success"
      />
      <Alert
        message="Pendiente de Pago"
        description="Acceso y funcionamiento normal del sistema hasta 15 días después de la Próxima Fecha de Pago."
        type="warning"
        showIcon
        icon={<ExclamationCircleOutlined />}
        className="licences-alert-warning"
      />
      <Alert
        message="Suspendido"
        description="Temporalmente sin acceso"
        type="error"
        showIcon
        icon={<StopOutlined />}
        className="licences-alert-error"
      />
      <Alert
        message="Baja"
        description="Sin acceso por finalización de contrato"
        type="info"
        showIcon
        icon={<MinusCircleOutlined />}
        className="licences-alert-info"
      />
    </Space>
  </Card>
);

export default StatusCard;